// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnerItem_root__DaHeq","name":"PartnerItem_name__pw0UX","logo":"PartnerItem_logo__UE4F3"};